import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.regexp.match.js";
export var validateEmail = email => /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(email);
export var validatePasswordLength = password => /[^]{8,}$/.test(password);
export var validatePasswordUppercase = password => /[A-Z]/.test(password);
export var validatePasswordLowercase = password => /[a-z]/.test(password);
export var validatePasswordSpecialCharacter = password => /[^a-zA-Z\d\s:]/.test(password);
export var validatePasswordNumber = password => /\d/.test(password);
export var validateName = name => /^([^0-9!@#$%^&*(),.?":{}|<>\\]{2,30})$/.test(name);
export var validateCity = name => /^([^!@#$%^&*(),?":{}|<>\\]{1,40})$/.test(name);
export var validateCompany = name => /^([^!@#$%^&*(),.?":{}|<>\\]{2,80})$/.test(name);
export var validateAddress = name => /^([^!@#$%^&*()?":{}|<>]{5,110})$/.test(name);
export var validateCommentary = name => /^([^!@#$%^&*()?":{}|<>\\]{2,40})$/.test(name);
export var validateBirthDay = birthDay => /^\s*(3[01]|[12][0-9]|0?[1-9])\/(1[012]|0?[1-9])\/((?:19|20)\d{2})\s*$/g.test(birthDay);
export var validateOrderBL = bl => /^[0-9]{8,10}$/.test(bl);
export var validateOrderBLMdmAndMkp = bl => /^[0-9]{8,10}-?[A-Z]?$/.test(bl);
export var isMarketplaceFormat = bl => /^[0-9]{8,10}-?[A-Z]$/.test(bl);
export var validateGiftCard = gc => /^[0-9]{13}$/.test(gc);

// TODO change to proper validation regex
export var validateBicCode = bicCode => /([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)/g.test(bicCode);
// TODO change to proper validation regex
export var validateIban = iban => /[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}/g.test(iban);
export var giftCardPriceValidator = {
  validate(value) {
    return value >= 20 && value <= 999 && !value.toString().match(/[,.e]/);
  }
};
export var discountInputValidator = {
  validate(value) {
    return !/[^a-zA-Z0-9]/.test(value);
  }
};